"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPrefixes = createPrefixes;
function createPrefixes({ i18n, prefixSlugs }) {
    const { locales, defaultLocale } = i18n;
    if (!locales.includes(defaultLocale)) {
        throw new Error(`Invalid defaultLocale: "${defaultLocale}"`);
    }
    return locales.flatMap((locale) => Object.values(prefixSlugs[locale] || {}));
}
